// extracted by css-extract-rspack-plugin
export default {"tickle":"Tickle-module__tickle__kbNNiys","copilotRun":"Tickle-module__copilotRun__nKMQ6Ps"};